import { createSlice } from '@reduxjs/toolkit';
import apiClient from '../Api/api_client';
import { loadingSlice } from './LoadingStore';

export const defaultPromotionsState = {
    promotions: [],
    promotionsDetail: [],
    error: '',
};

const getPromotionsReducer = (state, action) => {
    if (action.payload.promotions !== undefined) {
        return {
            ...state,
            promotions: action.payload.promotions,
        };
    } else {
        return state;
    }
};

const getPromotionsDetailReducer = (state, action) => {
    if (action.payload?.promotionData === undefined) {
        return state;
    }

    const promotions = [...state.promotionsDetail, action.payload.promotionData];
    return {
        ...state,
        promotionsDetail: promotions,
    };
};

const resetReducer = (state, action) => {
    return {
        ...defaultPromotionsState,
    };
};

const clearErrorsReducer = (state, action) => {
    return {
        ...state,
        error: '',
    };
};

export const promotionSlice = createSlice({
    name: 'promotions',
    initialState: defaultPromotionsState,
    reducers: {
        getPromotions: getPromotionsReducer,
        getPromotionsDetail: getPromotionsDetailReducer,
        reset: resetReducer,
        clearErrors: clearErrorsReducer,
    },
});

// ACTUAL ACTIONS
// a place to make the actions more complex if necessary

const getPromotions = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'getPromotions' }));
    const result = await apiClient.getPromotions();
    dispatch(promotionSlice.actions.getPromotions(result));
    dispatch(loadingSlice.actions.unsetLoading({ action: 'getPromotions' }));
};

const getPromotionsDetail = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'getPromotionsDetail' }));
    const result = await apiClient.getPromotionDetail(payload);
    dispatch(promotionSlice.actions.getPromotionsDetail(result));
    dispatch(loadingSlice.actions.unsetLoading({ action: 'getPromotionsDetail' }));
};

//actions that get exported to the views
export const promotionsActions = (dispatch) => {
    return {
        getPromotions: (payload) => getPromotions(dispatch, payload),
        getPromotionsDetail: (payload) => getPromotionsDetail(dispatch, payload),
        reset: (payload) => dispatch(promotionSlice.actions.reset(payload)),
        clearErrors: (payload) => dispatch(promotionSlice.actions.clearErrors()),
    };
};
